import { vaultFetch } from './vault-api-core.ts'

export type VaultPrincipalKind =
  'agent_role' | 'runner' | 'human' | 'agent_defaults'

export interface VaultPrincipalRow {
  id: string
  kind: VaultPrincipalKind
  name: string
  agentRoleId: string | null
  userId: string | null
  verified: boolean
  inherit: boolean
  [key: string]: unknown
}

export interface VaultRunnerCreateOut {
  principal: VaultPrincipalRow
  token: string
}

// ── principals ──────────────────────────────────────────────────────────
export async function listPrincipals(
  rootId: string,
): Promise<VaultPrincipalRow[]> {
  const { principals } = await vaultFetch<{
    principals: VaultPrincipalRow[]
  }>(`/vault/admin/${rootId}/principals`)
  return principals
}

export function createRunner(
  rootId: string,
  body: { name: string; verified: boolean },
): Promise<VaultRunnerCreateOut> {
  return vaultFetch<VaultRunnerCreateOut>(
    `/vault/admin/${rootId}/principals/runners`,
    { method: 'POST', body: JSON.stringify(body) },
  )
}

export function patchPrincipal(
  rootId: string,
  id: string,
  body: { inherit?: boolean; name?: string },
): Promise<VaultPrincipalRow> {
  return vaultFetch<VaultPrincipalRow>(
    `/vault/admin/${rootId}/principals/${id}`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
    },
  )
}
